import React from 'react';
import { useApplicationContext } from '../context/useApplicationContext';
import { ErrorMessage } from 'ui-toolkit';
import { SingleFieldValidationSchemaGenerator } from './SingleFieldValidationSchemaGenerator';
import { useAppDispatch } from 'store/store';
import { loadOrderAsyncAction } from 'store/order/batchedDispatches';
import { DisplaySingleFields, eSingleFields } from '../context/state/eSingleFields';
import { eApplicationActions } from '../context/actions/eApplicationActions';
import { useUpdateOrderTimberHook } from '../../../API/order/useUpdateOrderHook';
import { fieldToBody } from '../../order/overview/EditTransactionPrice/fieldNameToThings';
import { eEditSingleFieldInputType } from '../../../ui-toolkit/orders/components/EditSingleField/eEditSingleFieldInputType';
import { EditSingleFieldController } from '../../../ui-toolkit/orders/components/EditSingleField/EditSingleFieldController';

export interface IModalHandlerProps {
  trySaveCDItems: () => Promise<any> | null;
}

export const ModalHandler: React.FC<IModalHandlerProps> = ({ trySaveCDItems }) => {
  const [state, dispatch] = useApplicationContext();
  const { action: doOrderUpdate } = useUpdateOrderTimberHook();

  const reduxDispatch = useAppDispatch();

  const showDialog = state.isEditingSingleField;

  const inputType =
    state.editingSingleFieldName === eSingleFields.loan_number
      ? eEditSingleFieldInputType.String
      : eEditSingleFieldInputType.Currency;
  //useEffect moved to parent component

  if (state.order) {
    const doSubmit = async (x: number | string) => {
      if (x === null && state.editingSingleFieldName === eSingleFields.loan_number) {
        x = 'None';
      }
      if (state.order) {
        await doOrderUpdate(state.order, { [fieldToBody[state.editingSingleFieldName]]: x });
        reduxDispatch(loadOrderAsyncAction(state.order.transaction.id!));
        trySaveCDItems();
        return { message: '' };
      } else {
        return { message: 'No Order Information' };
      }
    };
    const onClose = (type: eApplicationActions.CloseEditSingleFieldAction) => () => {
      dispatch({ type });
    };
    return (
      <>
        {state.isEditingSingleField && showDialog ? (
          <EditSingleFieldController
            displayLabel={DisplaySingleFields[state.editingSingleFieldName]}
            actions={{ onClose: onClose(eApplicationActions.CloseEditSingleFieldAction), doSubmit }}
            inputType={inputType}
            value={state.order.transaction[state.editingSingleFieldName] || 0}
            validationSchema={SingleFieldValidationSchemaGenerator(
              state.order.transaction.transaction_category,
              state.editingSingleFieldName
            )}
          />
        ) : null}
      </>
    );
  } else {
    return <ErrorMessage>No Order Information</ErrorMessage>;
  }
};
